const rows = [
  { them: "They cut the fee.", us: "We redesigned the whole process." },
  { them: "Call centers and ticket queues.", us: "1-on-1 founder + Listing Concierge 7 days a week." },
  { them: "National scripts and generic advice.", us: "Central Florida specialists who know your zip code." },
  { them: "Just an MLS listing.", us: "A real marketplace — verified buyers, vetted local pros, real-time chat." },
  { them: "Add-on fees and confusing tiers.", us: "One flat 0.50% at closing. Nothing upfront. Nothing hidden." },
];

const WhyNotDiscountBroker = () => {
  return (
    <section className="bg-brand-warm-900 py-10 md:py-14 px-6">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-12 space-y-3">
          <span className="text-sm font-medium uppercase tracking-wider text-accent">Why not a discount broker</span>
          <h2 className="text-3xl md:text-5xl font-bold text-brand-warm-50">
            Discount brokers cut the fee. <br className="hidden md:block" />
            <span className="text-accent">We redesigned the process.</span>
          </h2>
        </div>

        <div className="bg-brand-warm-50 rounded-2xl overflow-hidden border border-brand-warm-100">
          <div className="grid grid-cols-2 border-b border-border bg-card">
            <div className="p-4 md:p-5 text-center text-sm font-semibold text-muted-foreground uppercase tracking-wider">
              Discount Brokers
            </div>
            <div className="p-4 md:p-5 text-center text-sm font-bold text-primary uppercase tracking-wider bg-primary/5">
              REALV3
            </div>
          </div>
          {rows.map((r, i) => (
            <div key={i} className="grid grid-cols-2 border-b border-border last:border-0">
              <div className="p-4 md:p-6 text-sm md:text-base text-muted-foreground leading-relaxed">
                {r.them}
              </div>
              <div className="p-4 md:p-6 text-sm md:text-base text-foreground font-medium leading-relaxed bg-primary/5">
                {r.us}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyNotDiscountBroker;
